import gql from "graphql-tag";

export default gql`
  query VideoLibrariesPaginated(
    $page: Int
    $perPage: Int
    $keyword: String
    $sortField: String
    $sortOrder: Int
    $sync: Boolean
  ) {
    videoLibrariesPaginated(
      page: $page
      perPage: $perPage
      keyword: $keyword
      sortField: $sortField
      sortOrder: $sortOrder
      sync: $sync
    ) {
      items {
        _id
        filename
        displayName
        url
        ext
        size
        duration
        mtime
      }
      total
      page
      perPage
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;
